module.exports = __webpack_public_path__ + "static/media/Img_6.aa531a9e.JPG";